/**
 *
 * @param dockHour - The dock hour in minutes to be formatted.
 * @description Converts dock hours from minutes to a string format of "HH:MM".
 * For example, 90 minutes will be formatted as "1:30".
 * @returns The formatted dock hour as a string.
 */
export const prettyDockHour = (dockHour: number) => {
  if (dockHour === undefined || dockHour === null) return;

  // If 0 or 24 hours, return "0:00"
  if (dockHour === 0 || dockHour === 1440) return '0:00';

  const hours = Math.floor(dockHour / 60);
  const minutes = dockHour % 60;

  return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
};

export const prettyDockHours = (from?: number, to?: number) => {
  if (!from || !to) return;

  return `${prettyDockHour(from)} - ${prettyDockHour(to)}`;
};
